import React, { useEffect } from "react";
import { Card, Descriptions, Layout, Table } from "antd";
import { observer } from "mobx-react";
import { useHistory, useLocation } from "react-router-dom";
import { Utils } from "../../common/Utils";
import moment from "moment";
import { RegionFilterBar } from "../../components/filter/RegionFilterBar";
import { SortOrder } from "antd/lib/table/interface";
import { engActivitiesStore } from "../../store/engTool/EngActivitiesStore";

export const EngActivities = observer(() => {
  const store = engActivitiesStore;

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  // const onEdit = (m) => {
  //   store.fundEdit.edit(m.id);
  // };

  const onPending = (pending) => {
    const query = new URLSearchParams({ pending });
    history.push({
      search: query.toString(),
    });
  };

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    console.log("sorter", sorter);
    store.sortedInfo = sorter;
    store.refresh();
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Activity Name",
      dataIndex: "name",
      key: "name.keyword",
      sorter: (a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()),
      render: (_, r) => r.title || r.customName || r.name,
      sortOrder: store.sortedInfo.columnKey === "name.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Share Code",
      dataIndex: "shareCode",
      key: "shareCode",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      // sorter: (a, b) => a.type - b.type,
      // render: (t) => FrTypes2[t],
      sortOrder: store.sortedInfo.columnKey === "type" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "School",
      dataIndex: ["org", "name"],
      // sorter: (a, b) => a.org.name.toLocaleLowerCase().localeCompare(b.org.name.toLocaleLowerCase()),
      key: "school",
    },
    { title: "Participants", key: "participants", dataIndex: ["participant", "title"] },
    {
      title: "Duration",
      key: "start",
      sorter: (a, b) => moment(a.start).valueOf() - moment(b.start).valueOf(),
      render: (_, r) => Utils.timeDuration(r),
      sortOrder: store.sortedInfo.columnKey === "start" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   sorter: true,
    //   key: "state",
    //   width: "8%",
    //   sortOrder: store.sortedInfo.columnKey === "state" ? (store.sortedInfo.order as SortOrder) : undefined,
    // },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   width: "30%",
    //   key: "description",
    // },
    {
      title: "",
      key: "opt",
      // render: (t, r) => (Store.isDivision ? null : <EditOutlined onClick={() => onEdit(r)} />),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <RegionFilterBar store={store} actionsSpan={16}></RegionFilterBar>

      <Card size="small">
        <Descriptions title="Summary">
          <Descriptions.Item label="Number of Activities"> {store.data.total || 0} </Descriptions.Item>
        </Descriptions>
        <Table
          size="small"
          onChange={onChange}
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
        />
      </Card>
    </Layout.Content>
  );
});
